module.exports = __webpack_public_path__ + "img/mw.d1bb3b24.svg";